import { DocumentTextIcon } from '@heroicons/react/20/solid'

import { DIMENSIONS, FIT_LABELS, JOB, MATCH_SCORE, fitOf } from '../content'
import { anim, prog, stagger } from '../motion'
import { Avatar, BeamBands, Box, Count, FitIcon } from '../primitives'

// Schritte: 0 Ergebnisse je Dimension · 1 Passungsprofil als PDF · 2 Glass Box statt Black Box
const TRACK = { x: 196, w: 290 }

// Legende im Passungsprofil: Hohe Passung 71 bis 100, Mittlere 41 bis 70
const SCORE_LABEL =
  MATCH_SCORE > 70
    ? FIT_LABELS.high
    : MATCH_SCORE > 40
      ? FIT_LABELS.mid
      : FIT_LABELS.low

export default function SceneMatch() {
  const hits = DIMENSIONS.filter((d) => fitOf(d) === 'high').length

  return (
    <>
      <Box
        x={40}
        y={40}
        w={560}
        h={560}
        className='sty-card'
        style={anim({ at: [0.01, 0.12], x: -30, y: 0 })}
      >
        <div className='sty-pad sty-row'>
          <Avatar initials='L' color='pink' size={44} />
          <div className='sty-grow'>
            <div className='sty-h4'>Lena K.</div>
            <div className='sty-muted'>{JOB}</div>
          </div>
          <span
            className='sty-badge sty-badge--blue'
            style={anim({ at: [0.76, 0.84], s: 0.6, y: 0 })}
          >
            Glass Box
          </span>
        </div>

        {DIMENSIONS.map((d, row) => {
          const markerAt = stagger(0.03, 0.02, 0.08, row)
          return (
            <div
              key={d.name}
              className='sty-abs'
              style={{ left: 0, top: 120 + row * 76, width: 560 }}
            >
              <div className='sty-dim-label' style={{ left: 24, top: 0 }}>
                {d.name}
              </div>
              <div
                className='sty-track'
                style={{ left: TRACK.x, top: 4, width: TRACK.w }}
              >
                <BeamBands ideal={d.ideal} trans={d.trans} />
              </div>
              <div
                className='sty-abs'
                style={{
                  left: TRACK.x + (d.lena / 100) * TRACK.w - 9,
                  top: 1
                }}
              >
                <div
                  className='sty-marker'
                  style={anim({
                    at: markerAt,
                    x: -(d.lena / 100) * TRACK.w,
                    y: 0
                  })}
                />
              </div>
              <div
                className='sty-abs'
                style={{
                  left: TRACK.x + TRACK.w + 18,
                  top: -4,
                  ...anim({ at: stagger(0.38, 0.025, 0.06, row), s: 0.3, y: 0 })
                }}
              >
                <FitIcon fit={fitOf(d)} />
              </div>
            </div>
          )
        })}

        <div
          className='sty-abs sty-row sty-legend'
          style={{ left: 24, top: 500, ...anim({ at: [0.42, 0.52], y: 10 }) }}
        >
          <span
            className='sty-legend-swatch'
            style={{ background: 'rgb(167 247 231)' }}
          />
          Idealbereich
          <span
            className='sty-legend-swatch sty-ml-4'
            style={{ background: 'rgb(253 218 148)' }}
          />
          Übergangsbereich
          <span className='sty-marker sty-marker--sm sty-ml-4' /> Lena
          <span className='sty-ml-4'>
            {hits} von {DIMENSIONS.length} im Idealbereich
          </span>
        </div>
      </Box>

      <Box
        x={630}
        y={40}
        w={290}
        h={270}
        className='sty-card sty-pdf'
        style={anim({ at: [0.34, 0.44], x: 30, y: 0 })}
      >
        <div className='sty-pdf__top'>
          <span className='sty-pdf__file'>
            <DocumentTextIcon width={13} height={13} /> PDF
          </span>
          Passungsprofil
        </div>
        <div className='sty-pdf__glance'>
          <Count to={MATCH_SCORE} at={[0.36, 0.5]} className='sty-pdf__score' />
          <div className='sty-pdf__bar'>
            <i
              style={{
                ...prog([0.36, 0.5]),
                width: `${MATCH_SCORE}%`,
                transform: 'scaleX(var(--p))'
              }}
            />
          </div>
        </div>
        <div className='sty-strong sty-mt-2'>{SCORE_LABEL}</div>
        <div className='sty-pdf__sections'>
          {['Chancen', 'Risiken', 'Interviewfragen'].map((t, i) => (
            <span
              key={t}
              style={anim({ at: stagger(0.44, 0.02, 0.05, i), y: 8 })}
            >
              {t}
            </span>
          ))}
        </div>
      </Box>

      <Box
        x={630}
        y={330}
        w={290}
        h={270}
        className='sty-blackbox'
        style={anim({ at: [0.68, 0.78], x: 30, y: 0 })}
      >
        <div className='sty-blackbox__q'>?</div>
        <div className='sty-blackbox__score'>Score 71&nbsp;%</div>
        <div className='sty-blackbox__why'>Warum? Unklar.</div>
        <div
          className='sty-blackbox__cross'
          style={{
            ...prog([0.76, 0.84]),
            opacity: 'var(--p)',
            transform: 'scale(calc(0.6 + 0.4 * var(--p)))'
          }}
        >
          <span />
          <span />
        </div>
      </Box>
    </>
  )
}
